import { defineMessages } from 'react-intl';

import { Cryptocurrency as CryptocurrencyType } from '#src/__generated__/globalTypes.ts';
import { RadioGroup } from '#src/atoms/inputs/RadioGroup/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useUpdateCryptocurrency } from '#src/hooks/useUpdateCryptocurrency.ts';
import { cryptocurrencySymbols } from '#src/lib/cryptocurrency.ts';

const messages = defineMessages({
  title: {
    defaultMessage: 'Are you more into ETH or SOL?',
  },
});

const options = [
  {
    value: CryptocurrencyType.WEI,
    label: cryptocurrencySymbols[CryptocurrencyType.WEI],
  },
  {
    value: CryptocurrencyType.LAMPORT,
    label: cryptocurrencySymbols[CryptocurrencyType.LAMPORT],
  },
];

export const Cryptocurrency = () => {
  const {
    cryptocurrency,
    walletPreferences: { showCryptoWallet },
  } = useCurrentUserContext();
  const { updateCryptocurrency } = useUpdateCryptocurrency();

  if (!showCryptoWallet) return null;

  return (
    <SettingsSection title={messages.title}>
      <RadioGroup
        withSpacing
        options={options}
        value={cryptocurrency}
        name="cryptocurrency"
        onChange={updateCryptocurrency}
      />
    </SettingsSection>
  );
};
